<script setup lang="ts">
defineProps<{
  data: MenuCtaRecord[]
}>()
const { menuHide } = useMenu()
</script>

<template>
  <nav
    v-if="data.length"
    class="fixed bottom-10 left-0 top-auto flex w-full transform-gpu flex-col gap-4 px-4 will-change-transform lg:bottom-auto lg:left-auto lg:right-10 lg:top-8 lg:!flex lg:w-fit lg:flex-row lg:p-0"
    role="navigation"
  >
    <Button
      v-for="(item, idx) in data"
      :key="idx"
      :label="item.title as string"
      :to="
        item.reference
          ? (usePathByType(item!.reference._modelApiKey, item.reference.slug as string) as string)
          : (item.externalLink as string)
      "
      :target="item.externalLink && '_blank'"
      :variant="item.primary ? 'cta' : 'solid'"
      size="xl"
      class="min-w-[10.5rem] uppercase"
      @click="menuHide()"
    />
  </nav>
</template>
